<template>
    <div id="app">
        <div
            v-if="isLogin"
            class="main"
        >
            <!-- <img
                src="@/assets/images/icon/bg.png"
                class="bg-login"
                v-if="isbg"
            /> -->
            <router-view></router-view>
            <v-footer v-if="isbg"></v-footer>
        </div>
        <div
            id="wrapper"
            v-if="!isLogin"
        >
            <v-header v-if="!isPayPlatform"></v-header>
            <div
                id="main"
                class="clearfix"
            >
                <div
                    id="left-wrap"
                    class="left"
                >
                    <v-left v-if="$store.state.showLeftStatus && !isPayPlatform"></v-left>
                </div>
                <div
                    id="right-wrap"
                    :class="['left', !$store.state.showLeftStatus ? 'full' : '']"
                >
                    <div id="main-content">
                        <keep-alive>
                            <router-view v-if="$route.meta.keepAlive">
                            </router-view>
                        </keep-alive>

                        <router-view v-if="!$route.meta.keepAlive">
                        </router-view>
                    </div>
                    <v-footer v-if="!isPayPlatform"></v-footer>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import header from "@/components/common/header";
import left from "@/components/common/left";
import footer from "@/components/common/footer";

export default {
    name: "App",
    components: {
        "v-header": header,
        "v-left": left,
        "v-footer": footer,
    },
    data () {
        return {
            isLogin: true, //是否显示头部和菜单，true:不显示，false:显示。
            isAttestation: false,
            isAllFlag: false,
            ifbg: true,

            isPayPlatform: false,
        };
    },
    created () {
        if (
            this.$route.name != "login" &&
            this.$route.name != "forgotpwd" &&
            this.$route.name != "personalinfo" &&
            this.$route.name != "verify" &&
            this.$route.name != "Info" &&
            this.$route.name != "Survey" &&
            this.$route.name != "Surveys"
        ) {
            //头部和菜单显示判断
            this.isLogin = false;
            this.isbg = true;
        } else {
            if (this.$route.name == "personalinfo") {
                if (this.$route.query.param == "1") {
                    this.isLogin = false;
                    this.isbg = false;
                } else {
                    this.isLogin = false;
                    this.$store.commit("SET_SHOWLEFTSTATUS", false);
                    this.isbg = true;
                }
            } else if (this.$route.name == "Info") {
                this.isLogin = true;
                this.isbg = false;
                window.document.title = "信息采集";
            } else if (
                this.$route.name == "Survey" ||
                this.$route.name == "Surveys"
            ) {
                this.isLogin = true;
                this.isbg = false;
                window.document.title = "问卷调查";
            } else {
                this.isLogin = true;
                this.isbg = true;
                if (this.$route.name == "forgotpwd") {
                    this.isbg = false;
                }
            }
        }
    },
    mounted () {
        const me = this;
        me.isPayPlatform = ["nonTax"].includes(me.$route.name);
        if (this.$route.query.showId && this.$route.name == "Survey") {
        } else {
            window.onload = function () {
                me.$global.fileurl =
                    "http://" + window.location.host + "/file/pub/upload";
                me.$global.height = document.documentElement.clientHeight;
                let content = document.getElementById("app");
                let height = me.$global.height;
                content.style.height = height + "px";
                let menu = document.getElementById("menu");
                let main = document.getElementById("main-content");
                let menu_height = me.$global.height - 62;
                if (menu_height < 500) {
                    menu_height = 500;
                }
                let main_height = menu_height - 62;
                if (menu) {
                    menu.style.height = menu_height + "px";
                    main.style.height = main_height + "px";
                }
            };
            window.onresize = function () {
                me.$global.height = document.documentElement.clientHeight;
                let content = document.getElementById("app");
                let height = me.$global.height;
                content.style.height = height + "px";

                if (me.isLogin == false) {
                    let menu = document.getElementById("menu");
                    let main = document.getElementById("main-content");
                    let menu_height = me.$global.height - 62;
                    if (menu_height < 500) {
                        menu_height = 500;
                    }
                    let main_height = menu_height - 62;
                    menu.style.height = menu_height + "px";
                    main.style.height = main_height + "px";
                }
            };
        }
    },
    watch: {
        //监听路由，判断头部和菜单是否显示
        $route (to, from) {
            if (
                to.name == "login" ||
                to.name == "forgotpwd" ||
                to.name == "verify" ||
                to.name == "Info" ||
                to.name == "Surveys"
            ) {
                this.isLogin = true;
                if (to.name == "Surveys" || this.$route.name == "forgotpwd") {
                    this.isbg = false;
                }
            } else if (to.name == "personalinfo") {
                if (this.$route.query.param == "1") {
                    this.isLogin = false;
                } else {
                    this.isLogin = false;
                    this.$store.commit("SET_SHOWLEFTSTATUS", false);
                    this.isbg = true;
                }
            } else {
                this.isLogin = false;
            }
        },
    },
};
</script>
<style lang="scss">
// @import './assets/css/bootstrap.min.css';
// @import './assets/css/style.scss';
@import "./assets/less/style.less";
.el-dialog {
    .el-dialog__body {
        max-height: 600px;
        overflow: auto;
    }
}
.main:before {
    content: "";
    display: table;
}
</style>



// WEBPACK FOOTER //
// src/App.vue